export default __webpack_public_path__ + "static/media/blip_lofi.abeecbc6.jpg";